const Card = ({ Content }) => {
  return (
    <div className="bg-secondary-color min-w-[201px] md:w-full h-48 flex flex-col items-center md:items-start justify-center p-5 rounded">
      {Content}
    </div>
  );
};

const SecoundSectionAccumelator = () => {
  return (
    <div className="w-full flex md:flex-row flex-col md:justify-between gap-4 md:text-left items-center  justify-center text-center my-14 ">
      <div className="self-center md:w-1/2 my-5">
        <p className="text-xl">H2A Medical Solutions</p>
        <h3 className="text-3xl md:text-3xl md:w-4/5 lg:w-1/2">Key Success Figures</h3>
      </div>
      <div className="flex gap-4 text-center justify-center items-center flex-wrap lg:flex-nowrap">
        <Card
          Content={
            <>
              <p>sold</p>
              <h3>1000+</h3>
              <p>Medical devices</p>
            </>
          }
        />
        <Card
          Content={
            <>
              <h3>300+</h3>
              <p>Medical facilities</p>
            </>
          }
        />
        <Card
          Content={
            <>
              <p>That Served</p>
              <h3>100,000+</h3>
              <p>Patients</p>
            </>
          }
        />
      </div>
    </div>
  );
};

const SecoundSection = () => {
  return (
    <div className="App m-auto lg:px-0 lg:w-[70%] w-full p-5 ">
      <section className="App-header lg:p-0 p-5 mt-12 bg-[#ffffff] ">
        <div className="lg:text-left flex lg:flex-row justify-center lg:justify-between gap-4 items-center flex-col my-14 ">
          <div>
            <h3 className="lg:w-4/6">
              Philips Sole Ultrasound Equipment Distributor In Egypt
            </h3>
            <br />
            <p className="line-height-5 text-xl lg:w-4/5 ">
              H2A Medical Solutions proudly serves as the agent and sole distributor of Philips medical systems for the Ultrasound product line in Egypt, handling both sales and maintenance. This exclusive partnership further reinforces H2A's commitment to delivering top-tier diagnostic equipment and services to healthcare providers in the region.
            </p>
          </div>
          <div className="w-full lg:w-1/2 flex items-center justify-center ">
            <img
              src={require("../../../assets/philips.png")}
              className="lg:w-full lg:m-0 m-10"
            />
          </div>
        </div>
        <SecoundSectionAccumelator />
      </section>
    </div>
  );
};

export default SecoundSection;
